import React from 'react';

export const modalContext = React.createContext('light');

export const ModalProvider = modalContext.Provider;
